/**
 * When this operator was last active (S0.2 / DA-3336).
 *
 * A MODULE-LEVEL value rather than React state, because every `useWrite`
 * instance has to see the same stamp — a hook-local one would make each
 * control track its own idleness and none of them agree.
 *
 * In memory only, deliberately. Persisting it would mean a session resumed
 * after a laptop was closed for a week could look recently active, which is
 * precisely the case the idle rule exists to catch. A reload starts the
 * clock, which is correct: reloading IS activity.
 *
 * `markActive` is called on real interaction, not on render or on a timer —
 * see `useActivityTracking`.
 */

let lastActivity: number | null = null;

/** Record that the operator did something. */
export function markActive(now: number = Date.now()): void {
  lastActivity = now;
}

/** When they last did, or null if nothing has been recorded this session. */
export function lastActiveAt(): number | null {
  return lastActivity;
}

/** Forget the stamp. For tests, and for sign-out. */
export function resetActivity(): void {
  lastActivity = null;
}
